import { render, staticRenderFns } from "./TabelaGenerica.vue?vue&type=template&id=28247ef4"
import script from "./TabelaGenerica.vue?vue&type=script&lang=js"
export * from "./TabelaGenerica.vue?vue&type=script&lang=js"
import style0 from "./TabelaGenerica.vue?vue&type=style&index=0&id=28247ef4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports